

exports.__esModule = true;

require('jquery');

require('angularPlaceHolderShim');

require('js/lib/index');

require('xo-tracking/dist/index');

var _index = require('squid/index');

var _middleware = require('js/lib/middleware');

require('pages/xo-landing/route');

require('pages/xo-login/route');

require('pages/xo-generic-error/route');

require('pages/xo-generic-message/route');

require('pages/xo-select-fi/route');

require('pages/xo-review/route');

require('pages/xo-authorization-message/route');

require('pages/xo-add-card/route');

require('pages/xo-add-fi/route');

require('pages/xo-add-card-meft/route');

require('pages/xo-add-tax-id/route');

require('pages/xo-add-shipping/route');

require('pages/xo-add-national-id/route');

require('pages/xo-update-card/route');

var _route = require('pages/xo-eConsent/route');

var _route2 = _interopRequireDefault(_route);

require('pages/xo-travel-rule/route');

var _route3 = require('pages/xo-nbr/route');

var _route4 = _interopRequireDefault(_route3);

var _route5 = require('pages/xo-framebust/route');

require('pages/xo-sepa/route');

require('pages/xo-end/route');

require('xo-login-components/src/fullpage-onetouch-upsell/route');

var _route6 = require('pages/xo-create-password/route');

var _route7 = _interopRequireDefault(_route6);

var _route8 = require('pages/xo-tokenization-info/route');

var _route9 = _interopRequireDefault(_route8);

require('pages/xo-inventory-soldout/route');

require('xo-page-components/src/done/route');

require('xo-form-components/src/phone/route');

require('xo-credit-components/src/bml-display/route');

require('xo-credit-components/src/choose-credit-offer/route');

require('xo-credit-components/src/redirect-to-cape/route');

require('./directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Route.extend('$xoCheckoutRoute', {

    path: 'checkout',
    directive: 'xo-checkout',
    titleContent: 'base.payPal',

    defaultState: 'checkout.landing',
    middleware: _middleware.$Middleware,

    children: [{
        name: '$LandingRoute'
    }, {
        name: '$LoginRoute',
        attributes: {
            token: 'token'
        }
    }, {
        name: '$GenericErrorRoute'
    }, {
        name: '$ChooseCreditOfferRoute',
        attributes: {
            token: 'token'
        }
    }, {
        name: '$RedirectToCapeRoute',
        attributes: {
            token: 'token'
        }
    }, {
        name: '$GenericMessageRoute'
    }, {
        name: '$FullpageOnetouchUpsellRoute'
    }, {
        name: '$SelectFiRoute',
        props: function props() {
            return { token: this.token };
        }
    }, {
        name: '$ReviewRoute'
    }, {
        name: '$AuthorizationMessageRoute'
    }, {
        name: '$AddPhoneRoute'
    }, {
        name: '$AddCardPageRoute'
    }, {
        name: '$AddFiPageRoute'
    }, {
        route: _route9['default'],
        props: function props() {
            return { token: this.token };
        }
    }, {
        name: '$AddCardMeftRoute'
    }, {
        name: '$AddTaxIdRoute'
    }, {
        name: '$TravelRuleRoute'
    }, {
        name: '$AddNationalIdRoute'
    }, {
        name: '$UpdateCardPageRoute'
    }, {
        name: '$AddShippingPageRoute',
        attributes: {
            token: 'token'
        }
    }, {
        name: '$xoSoldOutPageRoute'
    }, {
        route: _route2['default'],
        props: function props() {
            var _this = this;

            return {
                token: this.token,
                success: function success() {
                    return _this.goto('this.review');
                }
            };
        }
    }, {
        route: _route4['default'],
        props: function props() {
            return { token: this.token };
        }
    }, {
        route: _route5.$xoFrameBustRoute
    }, {
        name: '$SepaPageRoute',
        attributes: {
            token: 'token'
        }
    }, {
        name: '$EndRoute'
    }, {
        name: '$BMLDisplay',
        attributes: {
            'review-url': 'reviewUrl'
        }
    }, {
        name: '$DoneRoute'
    }, {
        route: _route7['default'],
        props: function props() {
            return {
                token: this.token
            };
        }
    }]
});


_index.$Route;

_middleware.$Middleware;

_route5.$xoFrameBustRoute;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-checkout/route.js
// module id = ./pages/xo-checkout/route.js
// module chunks = 1